import { AllergensButton } from 'features/generator/contentFormSections/MenuForm/Allergens/AllergensButton'
import { ALLERGEN_LIST } from 'features/generator/contentFormSections/MenuForm/Allergens/allergensConfig'
import { TMenuSectionProduct } from 'features/generator/contentFormSections/MenuForm/MenuForm'
import { useTranslations } from 'next-intl'

import { Image } from './MenuScreen'

export const ProductItem = ({
	product,
	demoMode,
}: {
	product: TMenuSectionProduct
	demoMode: boolean
}) => {
	const t = useTranslations()

	return (
		<div className="flex flex-col gap-4">
			{(product.image || product.localImageUrl) && (
				<Image
					image={product.image}
					localSrc={product.localImageUrl}
					demoMode={demoMode}
					className="aspect-auto h-auto !w-full"
				/>
			)}
			<div className="flex flex-col gap-2">
				{(product.name || product.nameTranslation) && (
					<div className="flex flex-col gap-1">
						{product.name && (
							<h4 className="type-body-medium break-keep font-semibold">
								{product.name}
							</h4>
						)}
						{product.nameTranslation && (
							<p className="type-body-caption break-keep text-dark-grey">
								{product.nameTranslation}
							</p>
						)}
					</div>
				)}

				{product.price && (
					<p className="type-body-medium break-keep font-semibold">
						{product.price}
					</p>
				)}
				{(product.description || product.descriptionTranslation) && (
					<div className="flex flex-col gap-1">
						{product.description && (
							<h4 className="type-body-small break-keep">
								{product.description}
							</h4>
						)}
						{product.descriptionTranslation && (
							<p className="type-body-caption break-keep text-dark-grey">
								{product.descriptionTranslation}
							</p>
						)}
					</div>
				)}
			</div>
			{product.allergens && product.allergens.length > 0 && (
				<div className="flex flex-wrap items-center gap-2">
					{ALLERGEN_LIST.filter((allergen) =>
						product.allergens?.includes(allergen.id),
					).map((allergen) => (
						<AllergensButton
							key={allergen.id}
							name={t(allergen.name)}
							Icon={allergen.Icon}
							className="rounded-4 py-1"
							textClassName="type-body-caption"
						/>
					))}
				</div>
			)}
		</div>
	)
}
